import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `reflow_soldering`,

  name: {
    [LOCALES.EN_US]: `Reflow Soldering`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.concept],

  tags: [],
} as const satisfies TTerm
